// NgRx
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  getCurrentUserDetailsLoad,
  getCurrentUserDetailsSuccess,
  getCurrentUserDetailsError,
  getCurrentUserRolesError,
  getCurrentUserRolesSuccess,
  userClearAllMessages,
} from './user.actions';

// Interfaces
import { IStoreMessage } from '@core/interfaces/store-message.interface';
import { UserProfileViewModel } from '@tech/api-clients/auth';

// Enums
import { StoreMessageTypes } from '@core/enums/store-message-types.enum';

export interface IUserState {
  user?: UserProfileViewModel | null;
  roles?: string[];
  loading?: boolean;
  message?: IStoreMessage | null;
}

export const userStateFeatureKey = 'userState';

export const initialState: IUserState = {
  user: null,
  roles: [],
  loading: true,
  message: null,
};

export const userReducer: ActionReducer<IUserState, Action> = createReducer(
  initialState,
  on(getCurrentUserDetailsLoad, (state) => ({
    ...state,
    loading: true,
  })),
  on(getCurrentUserDetailsSuccess, (state, { user }) => ({
    ...state,
    user: new UserProfileViewModel(user),
    loading: false,
    message: null,
  })),
  on(getCurrentUserDetailsError, (state, { error }) => ({
    ...state,
    loading: false,
    message: {
      type: StoreMessageTypes.Error,
      messageKey: 'getCurrentUserDetailsError',
      error,
    },
  })),
  on(getCurrentUserRolesSuccess, (state, { roles }) => ({
    ...state,
    roles: roles,
    loading: false,
    message: null,
  })),
  on(getCurrentUserRolesError, (state, { error }) => ({
    ...state,
    loading: false,
    message: {
      type: StoreMessageTypes.Error,
      messageKey: 'getCurrentUserRolesError',
      error,
    },
  })),
  on(userClearAllMessages, (state) => ({
    ...state,
    message: null,
  }))
);
